export const SEARCH_PARAM_KEY_SORT = 'sort';
export const SEARCH_PARAM_KEY_TYPE = 'type';
export const SEARCH_PARAM_KEY_PAGE_NUMBER = 'page';
